import { createSlice } from '@reduxjs/toolkit';

// Holds the handshake/login key material used to encrypt requests and decrypt
// responses (mirrors midani-frontend's securitySlice):
//  - serverPublicKey   → obtained from the /startup handshake; encrypts requests.
//  - serverPrivateKey  → returned by login; decrypts authenticated responses.
//  - localPublicKey /
//    localPrivateKey   → the client keypair used for the handshake + public APIs.
export const SecurityReducer = createSlice({
  name: 'security',
  initialState: {
    serverPublicKey: null,
    serverPrivateKey: null,
    localPublicKey: null,
    localPrivateKey: null,
  },
  reducers: {
    // Merge in whatever keys a handshake/login returned.
    updateSecurity: (state, action) => {
      Object.assign(state, { ...action.payload });
    },
    clearSecurity: (state) => {
      state.serverPublicKey = null;
      state.serverPrivateKey = null;
      state.localPublicKey = null;
      state.localPrivateKey = null;
    },
  },
});
